import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IDonorConnectMentorPerformanceMonth, IDonorConnectGroup, IDonorConnectSurveyType } from '@nkr/models/index';
import { DashActionCreators, AppActionCreators, IApplicationState, IDonorConnectMentorPerformanceResponse, IDonorConnectLookupDataResponse, IAppState } from '@nkr/store/index';
import { OverlayTrigger, Popover, Alert } from 'react-bootstrap';
import { TableWrapper } from '../../center-admin/billing/styles';
import Filters from './filters';
import { downloadFile } from '@nkr/services/download-file';
import { ExpandedRowWrapper, ExpandedRowWrapperBottom, ExpandedRowWrapperTop, ExpandWrapper } from './styles';
import { OrganType } from '@nkr/enums/organ-type';

enum Section {
    SurveysCompleted = 1
}

interface IOwnProps {
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<IDonorConnectLookupDataResponse>,
    getDonorConnectMentorPerformanceReport: (startDate: string, endDate: string, mentorId: number, groupList: IDonorConnectGroup, typeList: IDonorConnectSurveyType, organType: OrganType | null) => Promise<IDonorConnectMentorPerformanceResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    dateRange: number,
    status: number,
    selectedMentorId: number,
    startDate: string,
    endDate: string,
    donorConnectGroup: IDonorConnectGroup,
    donorConnectSurveyType: IDonorConnectSurveyType,
    organType: OrganType | null,
    donorConnectMentorPerformanceReport: IDonorConnectMentorPerformanceMonth[],
    mentorList: { id: number, firstName: string, lastName: string, donorConnectCaseLoad: number }[],
    expand: number[]
}

class DonorConnectMentorPerformance extends React.Component<TProps, IState> {
    readonly state: IState = {
        donorConnectMentorPerformanceReport: [],
        mentorList: [],
        dateRange: 0,
        selectedMentorId: 0,
        status: 0,
        startDate: '',
        endDate: '',
        donorConnectGroup: {
            Nkdo: true,
            Nkf: true,
            Nkr: true
        },
        donorConnectSurveyType: {
            NKR: true,
            DCN: true,
            DASH: true
        },
        organType: null,
        expand: []
    }

    componentDidMount = () => {
        this.setState({
            startDate: moment().subtract(11, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD')
        }, () => {
            this.getData();
        });
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            Promise.all([
                this.props.getDonorConnectMentorPerformanceReport(this.state.startDate, this.state.endDate, this.state.selectedMentorId, this.state.donorConnectGroup, this.state.donorConnectSurveyType, this.state.organType),
                this.props.getLookupData()
            ])
                .then(([listResponse, lookupDataResponse]) => {
                    if (listResponse.data.success && lookupDataResponse.data.success) {
                        let { userList } = lookupDataResponse.data.results;

                        this.setState({
                            donorConnectMentorPerformanceReport: listResponse.data.results.monthlyStats,
                            mentorList: userList
                        });
                    }

                    this.props.hideLoading();
                });
        });
    };

    refreshReportData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getDonorConnectMentorPerformanceReport(this.state.startDate, this.state.endDate, this.state.selectedMentorId, this.state.donorConnectGroup, this.state.donorConnectSurveyType, this.state.organType)
                .then(listResponse => {
                    if (listResponse.data.success) {
                        this.setState({
                            donorConnectMentorPerformanceReport: listResponse.data.results.monthlyStats,
                        });
                    }
                    this.props.hideLoading();
                });
        });
    }

    handleDateChange = (name: string, value: string) => {
        if (name == 'startDate') {
            this.setState({
                startDate: value
            });
        }

        if (name == 'endDate') {
            this.setState({
                endDate: value
            });
        }
    }

    handleDateRangeSearch = () => {
        this.refreshReportData();
    }

    handleMentorChange = (selectedMentorId: number) => {
        this.setState({
            selectedMentorId
        });
    }

    handleGroupChange = (e: React.FormEvent<HTMLInputElement>) => {
        let groupList = { ...this.state.donorConnectGroup }
        groupList[e.currentTarget.value] = !this.state.donorConnectGroup[e.currentTarget.value];

        this.setState({
            donorConnectGroup: groupList
        });
    }

    handleTypeChange = (e: React.FormEvent<HTMLButtonElement>) => {
        let typeList = { ...this.state.donorConnectSurveyType }
        typeList[e.currentTarget.value] = !this.state.donorConnectSurveyType[e.currentTarget.value];

        this.setState({
            donorConnectSurveyType: typeList
        });
    }

    handleOrganTypeChange = (organType: OrganType | null) => {
        this.setState({
            organType
        });
    }

    handleToggleExpand = (section: Section) => {
        let expand = [...this.state.expand];

        if (expand.indexOf(section) >= 0) {
            expand = expand.filter(s => s != section);
        } else {
            expand.push(section);
        }

        this.setState({
            expand
        });
    }

    handleExport = () => {
        let { startDate, endDate, donorConnectMentorPerformanceReport } = this.state;

        let columns = donorConnectMentorPerformanceReport.map(item => moment(item.monthYear).format('MM/DD/YYYY'));
        columns.splice(0, 0, 'Performance Type');
        columns.splice(columns.length + 1, 0, 'Total');

        let csvContent = columns.join(',') + '\n';
        csvContent += this.getRowDataForExport(this.state.donorConnectMentorPerformanceReport);

        downloadFile(csvContent, `donor-connect-mentor-performance-report_${startDate}_${endDate}.csv`, 'text/csv');
    }

    getRowDataForExport = (list: IDonorConnectMentorPerformanceMonth[]) => {
        let rows: string[][] = [];

        let map = [
            { label: 'ContactsAssigned', property: 'contactsAssigned' },
            { label: 'ContactsAttempted', property: 'contactsAttempted' },
            { label: 'Response Rate', property: 'responseRateCurrentMonth' },
            { label: 'ContactsMade', property: 'contactsMade' },
            { label: 'DisconnectsMade', property: 'disconnectsMade' },
            { label: 'Contacts Completion Rate', property: 'contactsCompletionRateCurrentMonth' },
            { label: 'SurveysCompleted', property: 'surveysCompleted' },
            { label: 'SurveysCompleted - WorkUp Completed', property: 'surveryCompletedType', subProperty: 'workUpCompleted' },
            { label: 'SurveysCompleted - PreOp Completed', property: 'surveryCompletedType', subProperty: 'preOpCompleted' },
            { label: 'SurveysCompleted - AtSurgery Completed', property: 'surveryCompletedType', subProperty: 'atSurgeryCompleted' },
            { label: 'SurveysCompleted - PostSurgery Completed', property: 'surveryCompletedType', subProperty: 'postSurgeryCompleted' },
            { label: 'Surveys Completion Rate', property: 'surveysCompletionRateCurrentMonth' },
            { label: 'Donations', property: 'donations' },
            { label: 'Donation Rate', property: 'donationRateCurrentMonth' },
            { label: 'Disconnect Rate', property: 'disconnectRateCurrentMonth' }

        ];

        map.forEach(item => {
            let r = list.map(e => {
                if (item.subProperty == null) {
                    return e[item.property];
                } else {
                    return e[item.property][item.subProperty];
                }
            });

            let totalDisconnectsMade = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.disconnectsMade);
            let totalContactsMade = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsMade);
            let totalSurveysCompleted = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.surveysCompleted);
            let totalContactsAssigned = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsAssigned);
            let totalContactsAttempted = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsAttempted);
            let totalDonationsMadeCompleted = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.donations);
            let totalValues = '';

            switch (item.label) {
                case 'ContactsAssigned':
                    totalValues = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsAssigned).toString();
                    break;
                case 'ContactsAttempted':
                    totalValues = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsAttempted).toString();
                    break;
                case 'Response Rate':
                    totalValues = _.round(totalContactsAssigned > 0 ? (totalContactsAttempted / totalContactsAssigned) * 100 : 0, 2).toString();
                    break;
                case 'ContactsMade':
                    totalValues = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsMade).toString();
                    break;
                case 'Contacts Completion Rate':
                    totalValues = _.round(totalContactsAssigned > 0 ? (totalContactsMade / totalContactsAssigned) * 100 : 0, 2).toString();
                    break;
                case 'SurveysCompleted':
                    totalValues = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.surveysCompleted).toString();
                    break;
                case 'Surveys Completion Rate':
                    totalValues = _.round(totalContactsAssigned > 0 ? (totalSurveysCompleted / totalContactsAssigned) * 100 : 0, 2).toString();
                    break;
                case 'Donations':
                    totalValues = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.donations).toString();
                    break;
                case 'Donation Rate':
                    totalValues = _.round(totalContactsAssigned > 0 ? (totalDonationsMadeCompleted / totalContactsAssigned) * 100 : 0, 2).toString();
                    break;
                case 'DisconnectsMade':
                    totalValues = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.disconnectsMade).toString();
                    break;
                case 'Disconnect Rate':
                    totalValues = _.round(totalContactsAssigned > 0 ? (totalDisconnectsMade / totalContactsAssigned) * 100 : 0, 2).toString();
                    break;
                default:
                    totalValues = '0';

            }

            r.splice(0, 0, item.label);
            r.splice(r.length + 1, 0, totalValues);
            rows.push(r);

        })

        return rows.map(r => r.join(',')).join('\n');
    }

    render = () => {
        const successResponseRateCurrMonthToolTip = (
            <Popover id="popover-trigger-hover-focus">
                <strong>Contacts Attempted/Contacts Assigned</strong>
            </Popover>
        );

        const successContactsRateCurrMonthToolTip = (
            <Popover id="popover-trigger-hover-focus">
                <strong>Contacts Made/Contacts Assigned</strong>
            </Popover>
        );

        const successSurveysRateCurrMonthToolTip = (
            <Popover id="popover-trigger-hover-focus">
                <strong>Surveys Completed/Contacts Assigned</strong>
            </Popover>
        );

        const successDonationRateCurrMonthToolTip = (
            <Popover id="popover-trigger-hover-focus">
                <strong>Donations/Contacts Assigned</strong>
            </Popover>
        );

        const successDisconnectRateCurrMonthToolTip = (
            <Popover id="popover-trigger-hover-focus">
                <strong>Disconnects/Donations Made</strong>
            </Popover>
        );

        const surveysCompletedExpanded = this.state.expand.indexOf(Section.SurveysCompleted) >= 0;

        let totalContactsAssigned = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsAssigned);
        let totalContactsAttempted = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsAttempted);
        let totalResponseRate = _.round(totalContactsAssigned > 0 ? (totalContactsAttempted / totalContactsAssigned) * 100 : 0, 2);

        let totalContactsMade = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.contactsMade);
        let totalContactsCompletedRate = _.round(totalContactsAssigned > 0 ? (totalContactsMade / totalContactsAssigned) * 100 : 0, 2);

        let totalSurveysCompleted = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.surveysCompleted);
        let totalSurveysCompletedCompletedRate = _.round(totalContactsAssigned > 0 ? (totalSurveysCompleted / totalContactsAssigned) * 100 : 0, 2);

        let totalDonationsMadeCompleted = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.donations);
        let totalDonationRate = _.round(totalContactsAssigned > 0 ? (totalDonationsMadeCompleted / totalContactsAssigned) * 100 : 0, 2);

        let totalDisconnectMadeCompleted = _.sumBy(this.state.donorConnectMentorPerformanceReport, item => item.disconnectsMade);
        let totalDisconnectRate = _.round(totalDonationsMadeCompleted > 0 ? (totalDisconnectMadeCompleted / totalDonationsMadeCompleted) * 100 : 0, 2);

        let group = this.props.app.user ? this.props.app.user.group : null;

        return (
            <div className='container-fluid'>
                <div style={{ marginBottom: 20 }}>
                    <h3 style={{ margin: 0 }}>Donor Mentor Mentor Performance Report</h3>
                </div>

                <Filters
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    mentorId={this.state.selectedMentorId}
                    group={group}
                    donorConnectGroup={this.state.donorConnectGroup}
                    donorConnectSurveyType={this.state.donorConnectSurveyType}
                    organType={this.state.organType}
                    mentorList={this.state.mentorList}
                    onDateChange={this.handleDateChange}
                    onMentorChange={this.handleMentorChange}
                    onGroupChange={this.handleGroupChange}
                    onTypeChange={this.handleTypeChange}
                    onOrganTypeChange={this.handleOrganTypeChange}
                    onSearch={this.handleDateRangeSearch}
                    onExport={this.handleExport}
                />

                {this.state.donorConnectMentorPerformanceReport.length > 0 ?
                    <TableWrapper responsive striped>
                        <thead>
                            <tr>
                                <th style={{ width: '17%' }}>Performance Type</th>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <th>{moment(item.monthYear).format('MMMM YY')}</th>
                                )}

                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Contacts Assigned</td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>{item.contactsAssigned}</td>
                                )}
                                <td>{totalContactsAssigned}</td>
                            </tr>

                            <tr>
                                <td>Contacts Attempted</td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>{item.contactsAttempted}</td>
                                )}
                                <td>{totalContactsAttempted}</td>
                            </tr>

                            <tr>
                                <td><b>Response Rate</b></td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>
                                        <OverlayTrigger trigger={['hover', 'focus']}
                                            placement="right" overlay={successResponseRateCurrMonthToolTip}>

                                            <b>{item.responseRateCurrentMonth}%</b>

                                        </OverlayTrigger>
                                    </td>
                                )}
                                <td><b>{totalResponseRate}%</b></td>
                            </tr>

                            <div style={{ height: '30px' }}></div>

                            <tr>
                                <td>Contacts Made</td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>{item.contactsMade}</td>
                                )}
                                <td>{totalContactsMade}</td>
                            </tr>

                            <tr>
                                <td><b>Contacts Completion Rate</b></td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>
                                        <OverlayTrigger trigger={['hover', 'focus']}
                                            placement="right" overlay={successContactsRateCurrMonthToolTip}>

                                            <b>{item.contactsCompletionRateCurrentMonth}%</b>

                                        </OverlayTrigger>
                                    </td>
                                )}
                                <td><b>{totalContactsCompletedRate}%</b></td>
                            </tr>

                            <div style={{ height: '30px' }}></div>

                            <tr>
                                <td style={{ color: surveysCompletedExpanded ? 'white' : null, backgroundColor: surveysCompletedExpanded ? 'green' : null }}>
                                    <div style={{ display: 'flex', marginLeft: '30px' }}>
                                        <ExpandWrapper style={{ cursor: 'default' }} onClick={() => this.handleToggleExpand(Section.SurveysCompleted)}>Surveys Completed </ExpandWrapper><div style={{ display: surveysCompletedExpanded ? 'none' : 'block' }}><b><span style={{ color: 'green' }}>&#60;&#60;-click here to expand</span></b></div>
                                    </div>
                                </td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td key={'sc-' + index}>{item.surveysCompleted}</td>
                                )}

                                <td>{totalSurveysCompleted}</td>
                            </tr>

                            {surveysCompletedExpanded && (
                                <>
                                    <ExpandedRowWrapperTop>
                                        <td style={{ textAlign: 'left', paddingLeft: 30 }}><b>Work Up</b></td>
                                        {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                            <td key={'sc-workUpComp-' + index}>{item.surveryCompletedType.workUpCompleted}</td>
                                        )}
                                    </ExpandedRowWrapperTop>
                                    <ExpandedRowWrapper>
                                        <td style={{ textAlign: 'left', paddingLeft: 30 }}><b>Pre Op</b></td>
                                        {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                            <td key={'sc-preOpComp-' + index}>{item.surveryCompletedType.preOpCompleted}</td>
                                        )}
                                    </ExpandedRowWrapper>
                                    <ExpandedRowWrapper>
                                        <td style={{ textAlign: 'left', paddingLeft: 30 }}><b>At Surgery</b></td>
                                        {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                            <td key={'sc-atSurgeryComp-' + index}>{item.surveryCompletedType.atSurgeryCompleted}</td>
                                        )}
                                    </ExpandedRowWrapper>
                                    <ExpandedRowWrapperBottom>
                                        <td style={{ textAlign: 'left', paddingLeft: 30 }}><b>Post Surgery</b></td>
                                        {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                            <td key={'sc-postSurgeryComp-' + index}>{item.surveryCompletedType.postSurgeryCompleted}</td>
                                        )}
                                    </ExpandedRowWrapperBottom>
                                </>
                            )}

                            <tr>
                                <td><b>Surveys Completion Rate</b></td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>
                                        <OverlayTrigger trigger={['hover', 'focus']}
                                            placement="right" overlay={successSurveysRateCurrMonthToolTip}>

                                            <b>{item.surveysCompletionRateCurrentMonth}%</b>

                                        </OverlayTrigger>
                                    </td>
                                )}
                                <td><b>{totalSurveysCompletedCompletedRate}%</b></td>
                            </tr>

                            <div style={{ height: '30px' }}></div>

                            <tr>
                                <td>Donations Made</td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>{item.donations}</td>
                                )}

                                <td>{totalDonationsMadeCompleted}</td>
                            </tr>

                            <tr>
                                <td><b>Donation Rate</b></td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>
                                        <OverlayTrigger trigger={['hover', 'focus']}
                                            placement="right" overlay={successDonationRateCurrMonthToolTip}>

                                            <b>{item.donationRateCurrentMonth}%</b>

                                        </OverlayTrigger>
                                    </td>
                                )}
                                <td><b>{totalDonationRate}%</b></td>
                            </tr>
                            <tr>
                                <td>Disconnects</td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>{item.disconnectsMade}</td>
                                )}

                                <td>{totalDisconnectMadeCompleted}</td>
                            </tr>

                            <tr>
                                <td><b>Disconnect Rate</b></td>
                                {this.state.donorConnectMentorPerformanceReport.map((item, index) =>
                                    <td>
                                        <OverlayTrigger trigger={['hover', 'focus']}
                                            placement="right" overlay={successDisconnectRateCurrMonthToolTip}>

                                            <b>{item.disconnectRateCurrentMonth}%</b>

                                        </OverlayTrigger>
                                    </td>
                                )}
                                <td><b>{totalDisconnectRate}%</b></td>
                            </tr>
                        </tbody>
                    </TableWrapper>
                    :
                    <div style={{ padding: '1%' }}>
                        <Alert bsStyle='info' style={{ textAlign: 'center' }}>Preparing report data...</Alert>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLookupData: () => {
            return dispatch(DashActionCreators.getDonorConnectLookupData());
        },
        getDonorConnectMentorPerformanceReport: (startDate, endDate, mentorId, groupList, typeList, organType) => {
            return dispatch(DashActionCreators.getDonorConnectMentorPerformanceReport(startDate, endDate, mentorId, groupList, typeList, organType));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorConnectMentorPerformance);